import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
export default class Utils
{
    static transitionIn(onComplete = null, duration = 500)
    {
        this.scene.cameras.main.once('camerafadeincomplete', ()=>{if(onComplete)onComplete();});
        this.scene.cameras.main.fadeIn(duration);
    }

    static transtionOut(onComplete = null, duration = 500)
    {
        this.scene.cameras.main.once('camerafadeoutcomplete', ()=>{if(onComplete)onComplete();});
        this.scene.cameras.main.fadeOut(duration);
    }

    /**
     * Press the + symbol to add another bezier point
     */
    static CreateBezierData()
    {
        let createBezier = ()=>{
            let startPoint = new Phaser.Math.Vector2(50, 50), controlPoint1 = new Phaser.Math.Vector2(50, 75), controlPoint2 = new Phaser.Math.Vector2(100, 25), endPoint = new Phaser.Math.Vector2(100, 50);
            let curve = new Phaser.Curves.CubicBezier(startPoint, controlPoint1, controlPoint2, endPoint);
            let graphics = this.scene.add.graphics();
    
            this.scene.input.setDraggable([
                this.scene.add.rectangle(startPoint.x, startPoint.y, 15, 15, 0xff0000).setInteractive().setData('vector', startPoint).setData('isControl', false).setAlpha(.5).setDepth(999),
                this.scene.add.rectangle(endPoint.x, endPoint.y, 15, 15, 0xff0000).setInteractive().setData('vector', endPoint).setData('isControl', false).setAlpha(.5).setDepth(999),
                this.scene.add.rectangle(controlPoint1.x, controlPoint1.y, 15, 15, 0x00ff00).setInteractive().setData('vector', controlPoint1).setData('isControl', true).setAlpha(.5).setDepth(999),
                this.scene.add.rectangle(controlPoint2.x, controlPoint2.y, 15, 15, 0x00ff00).setInteractive().setData('vector', controlPoint2).setData('isControl', true).setAlpha(.5).setDepth(999),
            ]);
    
            this.scene.input.on('dragend', function (pointer, gameObject, dragX, dragY) {
                console.log("StartPoint: (" + Math.round(startPoint.x) + ", " + Math.round(startPoint.y) + ")\n" + "ControlPoint1: (" + Math.round(controlPoint1.x) + ", " + Math.round(controlPoint1.y) + ")\n" +
                    "ControlPoint2: (" + Math.round(controlPoint2.x) + ", " + Math.round(controlPoint2.y) + ")\n" + "EndPoint: (" + Math.round(endPoint.x) + ", " + Math.round(endPoint.y) + ")\n" );
            });
    
            this.scene.input.on('drag', function (pointer, gameObject, dragX, dragY) {gameObject.setPosition(dragX, dragY).data.get('vector').set(dragX, dragY);});
            this.temporaryUpdate((nunya, delta)=>{ curve.draw(graphics.clear().lineStyle(3, 0xffffff, 1)); });
        }
        InputHelper.Listen(InputHelper.KeyCodes.PLUS, createBezier);
        createBezier();
    }
	
	 static ScreenLog(text)
    {
        if(this._screenLogTexts == null) this._screenLogTexts = [];

        let newText = this.scene.addText(0, 0, 30, 0xffffff, Object.keys(gameData.fonts)[0], text, null, false);
        newText.setShadow(4, 4, 0x00000);
        this._screenLogTexts.unshift(newText);

        if(this._screenLogTexts.length > 15) this._screenLogTexts.pop().destroy();

        for(let i = 0; i < this._screenLogTexts.length; i++)
        {
            this._screenLogTexts[i].y = i == 0 ? 0 : this._screenLogTexts[i-1].y + newText.height;
        }
    }

    static get FPS() {return this.scene.game.loop.actualFps;}

    static get DeltaTime() { return this.scene.game.loop.delta }
	
	 /**
     * @param {function(Number, Number)} updateMethod passes percentComplete as first var, deltaTime as second
     */
    static temporaryUpdate(updateMethod, duration, ease = null, onComplete = null)
    {
        this.scene.temporary_number = 0;
        let prevVal = 0;
        let updateTween = this.scene.addTween(this.scene, duration, {temporary_number: 1, onUpdate: ()=>{
            let normalizedChange = this.scene.temporary_number - prevVal;
            updateMethod(this.scene.temporary_number/1, this.DeltaTime);
            prevVal = this.scene.temporary_number;
        }}, ease, onComplete);
        return updateTween;
    }

    static TransitionScenes(oldScene, newScene_Name, duration, directionY = 1, directionX = 0, ease = "Sinusoidal", data = null)
    {
        oldScene.scene.launch(newScene_Name, data);
        let newChildren = oldScene.game.scene.keys[newScene_Name].children.list;
        let oldChildren = oldScene.children.list;

        oldScene.addDelay(0, ()=>{
            for(let i = 0; i < newChildren.length; i++)
            {
                let child = newChildren[i];
                let oldPos = {x: child.x, y: child.y};
                child.setPosition(child.x + (oldScene.size.width * directionX), child.y + (oldScene.size.height * directionY));
                oldScene.addTween(child, duration, {x: oldPos.x, y: oldPos.y}, ease);
            }
            for(let i = 0; i < oldChildren.length; i++)
            {
                oldScene.addTween(oldChildren[i], duration, {x: oldChildren[i].x - (oldScene.size.width - 2) * directionX, y: oldChildren[i].y - (oldScene.size.height - 2) * directionY}, ease);
            }
            oldScene.addDelay(duration, ()=>{
                oldScene.scene.stop();
            });
        });
    }

    static TopParent(object)
    {
        let curobject = object;
        while(1)
        {
            if(curobject.parentContainer == null) return curobject;
            curobject = curobject.parentContainer;
        }
    }

    static StagePos(object)
    {
        let curobject = object;
        let pos = {x: curobject.x, y: curobject.y};
        while(curobject.parentContainer != null)
        {
            curobject = curobject.parentContainer;
            pos.x += curobject.x;
            pos.y += curobject.y;
        }

        return pos;
    }

    static RemoveDuplicates(largeArr, toRemove)
    {
        let newArr = [];
        for(let i = 0; i < largeArr.length; i++)
        {
            if(toRemove.indexOf(largeArr[i]) == -1)
            {
                newArr.push(largeArr[i]);
            }
        }
        return newArr;
    }

    /**
     *  @param {AScene} scene 
     */
    static set CurrentScene(scene)
    {
        this.scene = scene;
    }

    /**
     * Adds the abilitiy to manipulate a given this.manipulatedObject. A and D change angle. Middle click sets position, W and S change scale. Up, Down, Left and Right change position.
     */
    static ManipulateObject(object, onManipulated = null, logData = true)
    {
        this.manipulatedObject = object;

        let logDataFunc = ()=>{
            console.log((object.frame ? "frame: " + object.frame.name + ",\n" : "") + "x: " + object.x + ", y: " + object.y + ",\nangle: " + object.angle + ",\nscaleX: " + object.scaleX + ",\nscaleY: " + object.scaleY);
        };

        InputHelper.Listen(InputHelper.KeyCodes.D, ()=>{
            this.manipulatedObject.angle++;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.A, ()=>{
            this.manipulatedObject.angle--;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.W, ()=>{
            let incrementX = this.manipulatedObject.scaleX > 0 ? .05 : -.05;
            let incrementY = this.manipulatedObject.scaleY > 0 ? .05 : -.05;
            this.manipulatedObject.scaleX += incrementX;
            this.manipulatedObject.scaleY += incrementY;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.S, ()=>{
            let incrementX = this.manipulatedObject.scaleX > 0 ? -.05 : .05;
            let incrementY = this.manipulatedObject.scaleY > 0 ? -.05 : .05;
            this.manipulatedObject.scaleX += incrementX;
            this.manipulatedObject.scaleY += incrementY;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.UP, ()=>{
            this.manipulatedObject.y -= 1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.DOWN, ()=>{
            this.manipulatedObject.y += 1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.LEFT, ()=>{
            this.manipulatedObject.x -= 1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.RIGHT, ()=>{
            this.manipulatedObject.x += 1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.OPEN_BRACKET, ()=>{
            this.manipulatedObject.scaleX *= -1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.CLOSED_BRACKET, ()=>{
            this.manipulatedObject.scaleY *= -1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        this.scene.input.on('pointerdown', (pointer)=>{
            if(!this.manipulatedObject || pointer.event.button != 1) return;
            let stagePos = Utils.StagePos(this.manipulatedObject);
            this.manipulatedObject.setPosition(this.scene.input.x + this.manipulatedObject.x - stagePos.x, this.scene.input.y + this.manipulatedObject.y - stagePos.y);
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
    }

    static Shuffle(array) 
    { 
        return array.map((a) => [Math.random(),a]).sort((a,b) => a[0]-b[0]).map((a) => a[1]);
    }

    static GetRandomString(stringLength = 8)
    {
        let chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
        let randomstring = '';
        for (let i = 0; i < stringLength; i++) 
        {
            let rand = Phaser.Math.Between(0, chars.length - 1);
            randomstring += chars[rand];
        }

        return randomstring;
    }

    static SaveObject(key, object)
    {
        ABCyaLib.Storage.saveObject(key, object);
    }

    static GetObject(key)
    {
        return ABCyaLib.Storage.getObject(key);
    }

    /**
     * BIG CIRCLE IS 1
     */
    static CircleFullyContainsCircle(x1, y1, r1, x2, y2, r2) 
    { 
        let dist = Math.sqrt(((x1 - x2) * (x1 - x2)) + ((y1 - y2) * (y1 - y2))); 

        return (dist + r2 <= r1);
    }

    /**
     * @returns {number} returns the points proximity to the edge > 1 is outside of the ellipse, < 1 is inside the ellipse
     */
    static pointWithinEllipse(ellipseX, ellipseY, ellipseWidth, ellipseHeight, x, y)
    {
        ellipseWidth*=.5;
        ellipseHeight*=.5;
        return (Math.pow((x - ellipseX), 2) / Math.pow(ellipseWidth, 2)) + (Math.pow((y - ellipseY), 2) / Math.pow(ellipseHeight, 2)); 
    }

    static get TWEEN_CONST() {
        return {
            CREATED: 0,
            INIT: 1,
            DELAY: 2,
            OFFSET_DELAY: 3,
            PENDING_RENDER: 4,
            PLAYING_FORWARD: 5,
            PLAYING_BACKWARD: 6,
            HOLD_DELAY: 7,
            REPEAT_DELAY: 8,
            COMPLETE: 9,
            PENDING_ADD: 20,
            PAUSED: 21,
            LOOP_DELAY: 22,
            ACTIVE: 23,
            COMPLETE_DELAY: 24,
            PENDING_REMOVE: 25,
            REMOVED: 26
        }
    }
}
